<template>
    <el-dialog title="更换系统管理员" append-to-body :visible.sync="replaceAdminDialog" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">
            <div class="replace_admin_wrap">
                <div class="replace_admin_top">
                    <ul>
                        <li :class="activeName == 1 ?'active' :''">
                            <span>1</span>身份验证
                        </li>
                        <div></div>
                        <li :class="activeName == 2 ?'active' :''">
                            <span>2</span>更换人员
                        </li>
                    </ul>
                    <p>您正在更改系统管理员，更换后您将失去最高管理权限，请谨慎操作</p>
                </div>
                <div class="replace_admin_bottom">
                    <template v-if="activeName == 1">
                        <el-form-item label="手机号" prop="phone">
                            <el-input v-model="formData.phone" placeholder="请输入当前管理员手机号" type="text"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码" prop="sms_code">
                            <el-input maxlength="6" placeholder="验证码" v-model="formData.sms_code">
                              <span  slot="suffix">
                                  <span class="line"></span>
                                  <el-button :disabled="getCodeBtnDisabled" @click="handleClickGetCode()"   type="text">
                                      {{getCodeText}}
                                  </el-button>
                              </span>
                            </el-input>
                        </el-form-item>
                    </template>

                    <template v-if="activeName == 2">
                          <el-form-item label="新管理员" prop="new_admin_uid">
                              <el-select v-model="formData.new_admin_uid" :remote-method="getUserList"  value collapse-tags  filterable  placeholder="请选择人员，可输入人员姓名搜索"  remote  size="small">
                                  <el-option :key="user.uid"  :label="user.name"  :value="user.uid"    v-for="user in userList">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                    </template>
                </div>

            </div>




        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button v-if="activeName == 1" type="primary" :disabled="BtnDisabled" @click.stop="handleDialogNext" >下一步</el-button>
            <el-button v-else type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" >完成</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {mapState} from "vuex";
import { GetUserList,SendPhoneCode,changeSystemAdmin,CheckVerifyCode,Logout } from "@/api/index.js"

export default {
    name:'replace_admin',
    props: {
        replaceAdminDialog: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            activeName:1,
            BtnDisabled:false,
            formData: {
                phone:'',
                sms_code:'',
                new_admin_uid: "",
            },
            formRules: {
                phone: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!value) return callback(new Error('请输入当前管理员手机号'))
                            if (!/^1[3456789]\d{9}$/.test(value)) return callback(new Error('请输入正确的手机号'))
                            if(this.userInfo.user.phone != value) return callback(new Error('请输入正确的管理员手机号'))
                            callback()
                        }
                    },
                ],
                sms_code: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!value) return callback(new Error('请输入验证码'))
                            if (!/^\d{6}$/.test(value)) return callback(new Error('请输入6位验证码'))
                            callback()
                        }
                    },
                ],

                new_admin_uid: [ {required: true, message: "请选择新管理员"} ]
            },
            userList:[],
            getCodeBtnDisabled:false,
            getCodeTime:60,
        }
    },
    computed: {
        ...mapState(["userInfo"]),
        getCodeText() {
            if (this.getCodeBtnDisabled) {
                return `${this.getCodeTime}秒后重新发送`;
            } else {
                return '获取验证码';
            }
        },

    },
    created() {
        this.getUserList()
    },
    methods: {
        // 获取验证码
        handleClickGetCode(type){
            if (!this.formData.phone) {
                return this.$toast('请输入手机号')
            }
            SendPhoneCode({
                phone: this.formData.phone,
                type: "system_admin_change"
            }).then(res => {
                if (res.code === 200) {
                    this.$toast('验证码发送成功')
                    this.getCodeBtnDisabled = true;
                    const timer = setInterval(() => {
                        if (this.getCodeTime > 0) {
                            this.getCodeTime--;
                        } else {
                            this.getCodeBtnDisabled = false;
                            clearInterval(timer);
                            this.getCodeTime = 60;
                        }
                    }, 1000);
                } else {
                    this.$toast(res.message)
                }
            })
        },
        //获取用户列表
        getUserList(keyword) {
            GetUserList({keyword}).then(res => {
                if (res.code === 200) {
                    this.userList = res.data || []
                } else {
                    this.$toast(res.message)
                }
            })
        },
        handleDialogClose() {
            this.$emit("update:replaceAdminDialog", false)
        },
        // 下一步
        handleDialogNext(){
            this.$refs.formData.validate(valid => {
                if (valid) {
                    const data = {
                        phone: this.formData.phone,
                        code: this.formData.sms_code,
                        type: "system_admin_change"
                    }
                    CheckVerifyCode(data).then(res => {
                        if (res.code == 200) {
                            this.activeName = 2
                        }
                        this.BtnDisabled = false
                    }).catch(() => {
                        this.$toast.clear();
                        this.BtnDisabled = false
                    })
                }
            })
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    let postData = JSON.parse(JSON.stringify(this.formData))
                    this.BtnDisabled = true;
                    changeSystemAdmin(postData).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                message: '更换成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    Logout({}).then((res) => {
                                        this.$store.dispatch("clearUserInfo");
                                        localStorage.clear()
                                        this.$router.push(`/login`);
                                    });
                                }
                            })
                        }
                        this.BtnDisabled = false;
                    })

                }
            })
        },

    }
}
</script>
<style lang="scss" scoped>
    .replace_admin_wrap{
        height: 220px;
        .replace_admin_top{
            width: 100%;
            ul{
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                li{

                    line-height: 24px;
                    span{
                        font-size: 14px;
                        color: rgba(102, 102, 102, 1);
                        width: 24px;
                        height: 24px;
                        background: rgba(255, 255, 255, 1);
                        border: 1px solid rgba(217, 217, 217, 1);
                        box-sizing: border-box;
                        line-height: 22px;
                        text-align: center;
                        border-radius: 50%;
                        display: inline-block;
                        margin-right: 8px;
                    }
                    &.active{
                        span{
                            background: rgba(25, 144, 255, 1);
                            color: #fff;
                            border-color: rgba(25, 144, 255, 1);
                        }
                        color: rgba(51, 51, 51, 1);
                        font-weight: bold;
                    }
                }
                div{
                    width: 118px;
                    height: 1px;
                    background: rgba(232, 232, 232, 1);
                    margin: 0 8px;
                }
            }
            p{
                margin-top: 16px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
                font-size: 14px;
                text-align: center;
            }
        }
        .replace_admin_bottom{
            margin-top: 24px;
        }
    }
</style>